<template>
  <div id="login">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row"></div>
      </div>

      <div
        class="separador text-center mt-5 py-5"
        data-aos="fade-up"
        data-aos-delay="600"
      >
        <p class="fXG amarillo">Registrar Asistente</p>
      </div>

      <div class="container-fluid">
        <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->

        <div class="row">
          <div
            class="col-md-12 pt-5 mt-5"
            data-aos="fade-left"
            data-aos-delay="500"
          >
            <div class="row">
              <div class="col-12">
                <p class="">
                  <strong>Clínica 10 am: </strong> {{ cuenta_10am }} disponibles
                </p>
                <p class="">
                  <strong>Clínica 11 am: </strong> {{ cuenta_11am }} disponibles
                </p>
                <p class="">
                  <strong>Clínica 12 pm: </strong> {{ cuenta_12pm }} disponibles
                </p>
                <p class="">
                  <strong>Torneo: </strong> {{ cuenta_torneo }} disponibles
                </p>
              </div>
            </div>

            <form @submit="signup($event)" class="py-5 r15  mr-lg-5">
              <div class="col-12 text-left pb-4 fXG">
                <span class="">REGISTRO DE INVITADO</span>
              </div>
              <div class="col-12">
                <div class="row pb-4">
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.codigo"
                      type="text"
                      placeholder="Clave de registro*"
                      required
                      readonly
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.nombre_1"
                      type="text"
                      placeholder="Nombre*"
                      @input="
                        signupForm.nombre_1 = $event.target.value.toUpperCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.nombre_2"
                      type="text"
                      placeholder="Segundo Nombre"
                      @input="
                        signupForm.nombre_2 = $event.target.value.toUpperCase()
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.apellido_paterno"
                      type="text"
                      placeholder="Apellido Paterno*"
                      @input="
                        signupForm.apellido_paterno =
                          $event.target.value.toUpperCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.apellido_materno"
                      type="text"
                      placeholder="Apellido Materno"
                      @input="
                        signupForm.apellido_materno =
                          $event.target.value.toUpperCase()
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.empresa"
                      type="text"
                      placeholder="Empresa*"
                      @input="
                        signupForm.empresa = $event.target.value.toUpperCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.puesto"
                      type="text"
                      placeholder="Puesto*"
                      @input="
                        signupForm.puesto = $event.target.value.toUpperCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.email_user"
                      type="email"
                      placeholder="Correo Electrónico*"
                      @input="
                        signupForm.email_user =
                          $event.target.value.toLowerCase()
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <!-- <div class="col-lg-5 pb-0">
                        
                        <select v-model="signupForm.codigo_pais" required>
                          <option value="">Código País</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>

                        </select>
                      </div> -->

                      <div class="col-lg-12 pb-0">
                        <!-- <div class="blanco fG">Correo Electrónico</div> -->
                        <input
                          v-model.trim="signupForm.telefono"
                          type="tel"
                          placeholder="Teléfono"
                          maxlength="10"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.movil"
                      type="tel"
                      placeholder="Móvil"
                      maxlength="10"
                    />
                  </div>

                  <div class="col-lg-12 pb-0">
                    <div class="">Tipo de asistente*</div>
                    <select v-model="signupForm.tipo" required>
                      <option value="">Tipo de asistente</option>
                      <option value="EQUIPO PROSA">EQUIPO PROSA</option>
                      <option value="PATROCINADOR">PATROCINADOR</option>
                      <option value="CLIENTE">CLIENTE</option>
                      
                    </select>
                  </div>

                  <div class="col-lg-12 pb-0">
                    <div class="">Prioridad del asistente</div>
                    <select v-model="signupForm.prioridad">
                      <option value="">Prioridad del asistente</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="VIP">VIP</option>
                      
                    </select>
                  </div>

                  <!-- <div class="col-lg-12 py-3">
                    <span class="pl-2"> ¿Asistirá a la comida?</span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.comida"
                        @change="changeComida($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div> -->

                  <!-- <div class="col-lg-12 py-3">
                    <span class="mt-4"
                      >Selecciona la actividad en la que participará:</span
                    >
                  </div> -->

                  <!-- <div class="col-lg-12 py-3">
                    <label class="pointer">
                      <select
                        v-model="signupForm.evento"
                        @change="changeEvento($event)"
                        required
                      >
                        <option value="">Actividad</option>
                        <option value="Ninguno">Ninguno</option>
                        <option value="Torneo">Torneo</option>
                        <option value="Clínica">Clínica de Golf</option>
                      </select>
                    </label>
                  </div> -->

                  <!-- <div class="col-lg-12 py-3">
                   

                    <span class="blanco pl-2">
                      ¿Participarás en el Torneo?</span
                    >
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.torneo"
                        @change="changeTorneo($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div> -->
                  <div class="col-lg-12 pb-0" v-if="signupForm.torneo == 'SI'">
                    <!-- <div class="blanco fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.handicap"
                      type="text"
                      placeholder="Handicap"
                    />
                  </div>
                  
                 
                 
                </div>

                

                <div class="row pb-5">
                  <div class="col-12 text-center">
                    <button
                      type="submit"
                      class="
                        pointer
                        d-flex
                        align-items-center
                        justify-content-center
                        btnaction
                        fG
                        ml-auto
                        mr-auto
                      "
                    >
                      ENVIAR
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
        <div class="row">
          <div class="col-12 py-5"></div>
        </div>
      </div>

      <Footer></Footer>
      <!-- <Glyphicons></Glyphicons> -->
    </section>
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNavLector";

import * as fb from "../firebase";
import * as moment from "moment";
import { ticketsCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    SiteNav,
    // Glyphicons,
  },
  data() {
    return {
      codigo_disponible: "",
      cuenta_10am: "",
      cuenta_11am: "",
      cuenta_12pm: "",
      cuenta_torneo: "",
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        comida: "NO",
        torneo: "NO",
        handicap: "",
        talla_tops: "",
        clinica: "NO",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
        tipo: "",
        prioridad: ""
      },

      columnsRegistros: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "codigo_pais",
        "telefono",
        "movil",
        "comida",
        "torneo",
        "handicap",
        "talla_tops",
        "clinica",
        "talla_guantes",
        "talla_cubrebocas",
        "terminos",
      ],
      columnsInvitados: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email",
        "codigo_pais",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registros: [],
      invitados: [],
      user: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_copaprosa2021"));

    this.getCodigoYDiponibilidad();
  },
  methods: {
    async changeStatusComida(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusComida.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTorneo(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTorneo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusClinica(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusClinica.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusTalla(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusTalla.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusGuantes(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusGuantes.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    async changeStatusCubrebocas(codigo, status) {
      console.log({ changeStatusCodigo: codigo });
      console.log({ changeStatus: status });

      this.$store.dispatch("showLoader", true);

      var qData = {
        codigo: codigo,
        status: status,
      };

      const https = require("https");

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "changeStatusCubrebocas.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data

            this.$store.dispatch("showLoader", false);
            this.getRegistros();
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);

            console.log("error callback");
            alert(error);
          }
        );
    },
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registros = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.reenvioForm.codigo = "";

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-invitado-lector.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
              this.signupForm.codigo = "";

              this.getCodigoYDiponibilidad();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
        comida: "",
        tipo: "",
        prioridad: ""

      };
      this.centroForm = {
        clasificacion: "",
        no_cliente: "",
        nombre_completo: "",
        cedis: "",
        objetivo_semanal: "",
      };
    },
    getCodigoYDiponibilidad() {
      console.log("get codigo y disponibilidad");

      const https = require("https");
      var qData = {};
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getCodigoYDisponibilidad.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.codigo_disponible = res.codigo_disponible;
              this.signupForm.codigo = res.codigo_disponible;
              this.cuenta_10am = res.cuenta_10am;
              this.cuenta_11am = res.cuenta_11am;
              this.cuenta_12pm = res.cuenta_12pm;
              this.cuenta_torneo = res.cuenta_torneo;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
  },
};
</script>

